<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { fade, fly } from "svelte/transition";
  import { comprehensive, modal, positions } from "./stores";
  import type { Position } from "./types";
  import { getCoordinate, getDistance, getUrl } from "./utils";

  const handleEscape = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      modal.set("");
    }
  };

  let position: Position;
  $: position = $positions.find((pos) => pos.identifier === $modal);

  let distance: string;
  $: distance = position === undefined ? "-" : getDistance(position.addressData.distanceFromPosition);

  let url: string;
  $: url = position === undefined ? "" : getUrl(position, $comprehensive);

  onDestroy(() => {
    window.removeEventListener("keyup", handleEscape, false);
  });

  onMount(() => {
    window.addEventListener("keyup", handleEscape, false);
  });
</script>

{#if position}
  <div class="background" on:click={() => modal.set("")} transition:fade />
  <div aria-modal="true" class="modal" role="dialog" transition:fly={{ y: 100 }}>
    <div class="head">
      <h3 class="title">{position.addressData.address}</h3>
      <button aria-label="Lukk" class="btn-close" on:click={() => modal.set("")} type="button" />
    </div>
    <div class="body">
      <dl class="dl">
        <dt class="dt">Nærmeste adresse:</dt>
        <dd class="dd">
          <span class="d-block">{position.addressData.address}</span>
          <span class="d-block">{position.addressData.zipCode} {position.addressData.place}</span>
          <span class="d-block">{position.addressData.municipality}</span>
          <span class="d-block">{distance} unna punktet</span>
        </dd>
        <dt class="dt">Koordinatsystem:</dt>
        <dd class="dd">
          {position.coordinateSystem.name}
        </dd>
        <dt class="dt">Øst-koordinat:</dt>
        <dd class="dd">{getCoordinate(position.coordinates.y)}</dd>
        <dt class="dt">Nord-koordinat:</dt>
        <dd class="dd">{getCoordinate(position.coordinates.y)}</dd>
        <dt class="dt">Koordinater for mobil enhet:</dt>
        <dd class="dd">
          {getCoordinate(position.referenceCoordinates.x)}, {getCoordinate(position.referenceCoordinates.y)}
        </dd>
        <dt class="dt">Lenke til resultat:</dt>
        <dd class="dd">
          <a href={url}>{url}</a>
        </dd>
      </dl>
    </div>
  </div>
{/if}

<style>
  .background {
    background: #000;
    height: 100vh;
    left: 0;
    opacity: 0.5;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 1050;
  }
  .modal {
    top: calc(50% + 40px);
    left: calc(50% + 160px);
    position: fixed;
    transform: translate(-50%, -50%);
    width: 600px;
    z-index: 1055;
  }
  .head {
    align-items: center;
    background-color: #e3e3e3;
    border-bottom: solid 1px #222;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    justify-content: space-between;
    padding: 8px 24px;
  }
  .body {
    background-color: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 16px 24px;
  }
  .dl {
    display: flex;
    flex-wrap: wrap;
  }
  .dt {
    font-weight: bold;
    width: 40%;
  }
  .dd {
    width: 60%;
  }
</style>
